<template>
  <div style="background-color: #e6e6e6;">
    <HeaderView :title="$t('mine.giftrecord')" />
    <div class="view-page">
      <van-pull-refresh
        :pulling-text="$t('common.repulling')"
        :loosing-text="$t('common.reloosing')"
        :loading-text="$t('common.reloading')"
        :success-text="$t('common.resuccess')"
        v-model="isLoading"
        @refresh="onRefresh"
      >
        <van-empty
          v-if="list.length === 0"
          :description="$t('withdraw.empty_data')"
        />
        <div v-else class="item_list" v-for="(v, key) in list" :key="key">
          <div class="lottery_info">
            <van-image class="cover" :src="v.ico">
              <template v-slot:loading>
                <van-loading type="spinner" />
              </template>
            </van-image>
            <span class="period-number">{{ v.expect }}</span>
            <span class="period-number">{{
              v.name == "bi"
                ? "A"
                : v.name == "sm"
                ? "B"
                : v.name == "si"
                ? "C"
                : v.name == "do"
                ? "D"
                : ""
            }}</span>
          </div>
          <div class="recent">
            <div class="kuaisan-ball left">
                <van-image class="res-img" :src=" v.status === 0 ? 'img/lottery/open_num.gif' : 'img/lottery/shaizi/' + v.opencode[0] + '.png' " >
                <template v-slot:loading>
                  <van-loading type="spinner"/>
                </template>
              </van-image>
              <van-image class="res-img" :src=" v.status === 0 ? 'img/lottery/open_num.gif' : 'img/lottery/shaizi/' + v.opencode[1] + '.png' " >
                <template v-slot:loading>
                  <van-loading type="spinner"/>
                </template>
              </van-image>
              <van-image class="res-img" :src=" v.status === 0 ? 'img/lottery/open_num.gif' : 'img/lottery/shaizi/' + v.opencode[2] + '.png' " >
                <template v-slot:loading>
                  <van-loading type="spinner"/>
                </template>
              </van-image>

              <span class="res-des middle">{{
                v.status === 0
                  ? 0
                  : v.opencode[0] + v.opencode[1] + v.opencode[2]
              }}</span>
              <span class="res-des middle">{{
                v.status === 0
                  ? 0
                  : v.opencode[0] + v.opencode[1] + v.opencode[2] >= 11 &&
                    v.opencode[0] + v.opencode[1] + v.opencode[2] <= 18
                  ? $t("reservation.big")
                  : $t("reservation.small")
              }}</span>
              <span class="res-des middle">{{
                v.status === 0
                  ? 0
                  : (v.opencode[0] + v.opencode[1] + v.opencode[2]) % 2 === 0
                  ? $t("reservation.double")
                  : $t("reservation.single")
              }}</span>
            </div>
          </div>
          <div style="width: 100%">
            <ul style="line-height: 1.4">
              <li v-for="(n, nkey) in v.data" :key="nkey">
                <div style="width: 45%; float: left; padding-left: 0.5rem">
                  {{ n.type }}
                </div>
                <div
                  style="
                    width: 45%;
                    float: right;
                    text-align: right;
                    padding-right: 0.1rem;
                    color: red;
                  "
                >
                  {{ n.money }}
                </div>
              </li>
            </ul>
            <div style="clear: both"></div>
          </div>
          <div class="topInfo" style="width: 100%;height: 38px;line-height: 38px;">
            <span v-if="v.status === 1" style="color: #07c160"
              >{{ v.status_text }}&nbsp;</span
            >
            <span v-else>{{ v.status_text }}&nbsp;</span>
            <span>{{ $t("reservation.money") }}：{{ v.money }}</span>
          </div><div style="clear: both;" />
          <div style="height: 28px;">
            <span>{{ $t("reservation.order_time") }}：{{ v.create_time }}</span>
          </div>
          <div style="height: 28px;">
            <span
              >{{ $t("reservation.settle_time") }}：{{ v.update_time }}</span
            >
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import HeaderView from "../../components/Header/index.vue";
export default {
  name: "GameRecord",
  components: { HeaderView },
  data() {
    return {
      isLoading: false,
      list: [],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserWithdrawList() {
      this.$http({
        method: "get",
        url: "user_get_game_list",
      }).then((res) => {
        if (res.code === 200) {
          this.list = res.data;
          console.log(this.list)
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/login" });
    } else {
      this.getUserWithdrawList();
    }
  },
};
</script>
<style lang="scss" scoped>
.item_list{
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;

}

.item_list .topInfo span{
  flex: 1;
  font-size: 16px;
  font-weight: 700;
  color: #ff253f;
}
.item_list .time span{
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #000;
}

.item_list .topInfo span:last-child{
  float: right;
}
.item_list .desc span{
  font-size: 14px;
  font-weight: 700;
  color: #9b9b9b;
}
.item_list .cover{
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
}
.item_list  .period-number{
  margin-left: 50px;
  margin-right: 10px;
  height: 50px;
  line-height: 60px;
  font-size: 16px;
  font-weight: 700;
  color: #000;
}
.item_list .lottery_info{
  display: flex;
}
.recent {
  display: flex;
  align-items: center;
  height: 50px;
  color: #000;
}
.kuaisan-ball .left{
  justify-content: flex-start;
}
.kuaisan-ball{
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img{
  width: 28px;
  height: 28px;
  margin-right: 8px;
}
.kuaisan-ball .res-des{
  font-weight: 700;
  text-align: center;
  color: #000;
}
.kuaisan-ball .res-des.middle{
  min-width: 15%;
  font-size: 16px;
}
</style>
